<template>
  <section class="module dt-episode">
    <template v-if="nav && nav.length">
      <h3 v-if="lastDate">
        选集<span>更新至第{{ lastDate }}期</span>
      </h3>
      <div class="dt-episode-wrap zy-select">
        <div class="dt-episode-choose">
          <select
            v-model="selected"
            @change="selectChange"
          >
            <option
              v-for="(item, index) in nav"
              :key="index"
              :value="index"
            >
              {{ item }}
            </option>
          </select>
        </div>
      </div>
    </template>
    <div class="dt-epitasis-detail">
      <template v-if="showList && showList.length">
        <div class="dt-epitasis-detail-list">
          <a
            v-for="(item, index) in showList"
            :key="index"
            :href="playUrl(item)"
            :uigs="'play_' + item.date"
            :uigsparams="`play_type=lvideo&play_url=${encodeURIComponent(item.playlink)}&play_site=${site}`"
          >
            <div class="img">
              <Image-1 :src="getResizePicUrl(item.picurl, 115, 65, 200839)" />
              <span class="tag-time">{{ item.duration }}</span>
            </div>
            <div class="info">
              <p>{{ item.title }}</p>
              <p>
                {{ item.date.substring(0, 4) + '-' + item.date.substring(4, 6) + '-' + item.date.substring(6, 8) }}期
              </p>
            </div>
          </a>
        </div>
      </template>
      <a
        v-show="showMoreBtn"
        v-if="showList && showList.length"
        href="javascript:void(0);"
        class="dt-more down"
        @click="loadMore"
      >
        <span>更多往期节目</span>
      </a>
    </div>
  </section>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';

import Image from './Image.vue';

export default {
  components: {
    'Image-1': Image,
  },
  data() {
    return {
      playIndexInfo: 0,
      showList: [],
      site: '',
      selected: 0,
      dateInfo: '',
      showMoreBtn: true,
      listIndex: 0,
      lastDate: '',
    };
  },
  computed: {
    ...mapState('detail', ['itemData', 'playInfoIndex']),
    dockey() {
      return this.itemData.dockey;
    },
    query() {
      return this.itemData.name;
    },
    nav() {
      let dateInfo = (
        this.itemData.ipad_play_from_open_index
          && this.itemData.ipad_play_from_open_index.item_list
      ) || [];

      if (dateInfo && dateInfo.length) {
        dateInfo = dateInfo[this.playIndexInfo];
        const text = this.calDate(dateInfo);
        return Object.keys(text);
      }

      return [];
    },
    playIndex() {
      return this.playInfoIndex;
    },
  },
  watch: {
    playIndex(newV, oldV) {
      if (newV !== oldV) {
        this.selected = 0;
        this.playIndexInfo = newV;
        this.getInitialData();
      }
    },
  },
  mounted() {
    this.getInitialData();
  },
  methods: {
    async getInitialData() {
      let Info = (this.itemData && this.itemData.ipad_play_from_open_index) || {};
      if (Info && Info.item_list && Info.item_list.length) {
        Info = Info.item_list[this.playIndexInfo];
        const text = this.calDate(Info);
        this.site = Info.site;
        this.dateInfo = text;
        const getDate = Object.values(this.dateInfo)[this.selected];
        const dateArray = getDate.slice(0, 4);
        if (getDate.length <= (this.listIndex + 1) * 4) {
          this.showMoreBtn = false;
        }
        try {
          let ret = await this.ajaxPromise(dateArray);
          ret = this.formateData(ret, this.dockey, this.site, dateArray);
          if (ret && ret.length) {
            const item = ret[0].date;
            // 最新一期
            this.lastDate = `${item.substring(0, 4)}-${item.substring(4, 6)}-${item.substring(6, 8)}`;
            this.showList = ret;
          }
        } catch (e) {
          console.log(e);
        }
      }
    },
    calDateItem(year, month, day, count) {
      const list = [];
      for (let i = 0; i < day.length; i += 1) {
        const d = day[i];
        const l = d.length;
        for (let k = d[0]; k <= d[l - 1]; k += 1) {
          const dd = k < 10 ? `0${k}` : k;
          const txt = `${year}${month}${dd}`;
          let times = 1;
          if (count && count.length) {
            for (let countIndex = 0; countIndex < count.length; countIndex += 1) {
              if (count[countIndex] && count[countIndex].length === 2 && count[countIndex][0] === k) {
                [, times] = count[countIndex];
                break;
              }
            }
          }
          list.push(txt);
          if (times > 1) {
            for (let pushTimes = 1; pushTimes < times; pushTimes += 1) {
              list.push(`${txt}_${pushTimes + 1}`);
            }
          }
        }
      }

      const compFunc = function (a, b) {
        return a < b ? 1 : -1;
      };
      list.sort(compFunc);
      return list;
    },
    calDate(dateInfo) {
      const dateObj = {};

      if (dateInfo) {
        const dateInfoDate = dateInfo.date;
        if (dateInfoDate && dateInfoDate.length) {
          dateInfoDate.sort((a, b) => {
            if (a.year < b.year) return 1;
            if (a.year === b.year && a.month < b.month) return 1;
            return -1;
          });

          for (let j = 0; j < dateInfoDate.length; j += 1) {
            const { year, day, count } = dateInfoDate[j];
            let { month } = dateInfoDate[j];
            const list = this.calDateItem(year, month, day, count);
            month = month.indexOf('0') === 0 ? month.substring(1, 2) : month;
            const text = `${year}年${month}月`;
            dateObj[text] = list;
          }
        }
      }

      return dateObj;
    },
    async ajaxPromise(dateArray) {
      let fieldlist = 'name,play_from_open/';
      for (const temp of dateArray) {
        fieldlist += `${this.site}_${temp}:`;
      }
      const params = { field_list: fieldlist, dockey_list: this.dockey };
      const res = await axios.get('/napi/video/element', { timeout: 2000, params }).catch((e) => {
        console.log('[EPISODE_TVSHOW_ERROE]', e);
      });
      return (res && res.data && res.data.data) || '';
    },
    async selectChange() {
      this.showMoreBtn = true;
      this.listIndex = 0;
      const info = Object.values(this.dateInfo);
      if (info[this.selected].length <= (this.listIndex + 1) * 4) {
        this.showMoreBtn = false;
      }
      const dateList = info[this.selected].slice(0, 4);
      try {
        let result = await this.ajaxPromise(dateList);
        result = this.formateData(result, this.dockey, this.site, dateList);
        this.showList = result;
      } catch (e) {
        console.log(e);
      }
    },
    async loadMore() {
      this.listIndex += 1;
      const info = Object.values(this.dateInfo);
      const num = this.listIndex;
      if (info[this.selected].length <= (num + 1) * 4) {
        this.showMoreBtn = false;
      }
      const dateList = info[this.selected].slice(4 * num, 4 * (num + 1));
      try {
        let result = await this.ajaxPromise(dateList);
        result = this.formateData(result, this.dockey, this.site, dateList);
        this.showList = [].concat(this.showList, result);
      } catch (e) {
        console.log(e);
      }
    },
    playUrl(obj) {
      const queryPart = `${this.query} ${obj.date}`;
      const url = `/play?query=${encodeURIComponent(queryPart)}&date=${obj.date}&key=${this.dockey}&st=5&tvsite=${
        this.site
      }`;
      return url;
    },
    formateTime(duration) {
      let durationStr = '';
      if (duration) {
        const duarationNum = parseInt(duration, 10);
        const hour = Math.floor(duarationNum / 3600);
        const min = Math.floor((duarationNum - hour * 3600) / 60);
        const sec = duarationNum - hour * 3600 - min * 60;

        if (sec < 0 || hour < 0 || min < 0) {
          return durationStr;
        }

        if (!(min === 0 && sec === 0 && hour === 0)) {
          if (hour !== 0) {
            durationStr = `${hour}:`;
          }
          if (min === 0) {
            durationStr += '00:';
          } else {
            if (min < 10) durationStr += `0${min}:`;
            else durationStr += `${min}:`;
          }
          if (sec === 0) {
            durationStr += '00';
          } else if (sec > 0) {
            if (sec < 10) durationStr += `0${sec}`;
            else durationStr = durationStr + sec;
          }
        }
      }
      return durationStr;
    },
    formateData(data, dockey, site, dateArray) {
      const ret = [];
      if (data) {
        const { results } = data;
        if (results && Object.keys(results).length) {
          const { play_from_open: playFromOpen } = results[dockey];
          if (playFromOpen) {
            for (const date of dateArray) {
              if (date === null || date === '') continue;
              const temppath = `${site}_${date}`;
              let duration = playFromOpen[temppath].duration || '';
              duration = this.formateTime(duration);
              const title = playFromOpen[temppath].title || '';
              let picurl = playFromOpen[temppath].picurl || '';
              if (picurl.indexOf('http://') === 0 && picurl.indexOf('sogoucdn.com') > -1) {
                picurl = picurl.replace('https://', 'https://');
              }
              const playlink = playFromOpen[temppath].playlink || '';
              const vip = playFromOpen[temppath].vip || '';
              ret.push({ date, duration, title, picurl, playlink, vip });
            }
          }
        }
      }
      return ret;
    },
    getResizePicUrl(url, width, height, appid) {
      // 获取云图裁剪图片地址
      if (url === null || url === '') return '';
      const r = Math.floor(Math.random() * 4) + 1;
      let newurl = '';
      newurl = `https://img0${r}.sogoucdn.com/v2/thumb/resize/w/${width}/h/${height}/t/0/retype/ext/auto/q/75?appid=${appid}&url=${encodeURIComponent(url)}`;
      return newurl;
    },
  },
};
</script>

<style lang="scss">
@import '../../../asset/css/abstracts/mixin.scss';
@import '../../../asset/css/abstracts/function_sprite_detail.scss';

.dt-epitasis-detail-list {
  padding: 0 14px;

  > a {
    display: block;
    height: 65px;
    margin-bottom: 15px;
    position: relative;

    .img {
      width: 115px;
      height: 65px;
      border-radius: 5px;
      overflow: hidden;
      float: left;
      margin-right: 10px;
      position: relative;

      &:before {
        content: '';
        width: 100%;
        height: 50px;
        position: absolute;
        bottom: 0;
        left: 0;
        background: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .img .imgerror:before {
      content: none;
    }
    .tag-time {
      color: #fff;
      font-size: 13px;
      position: absolute;
      right: 6px;
      bottom: 6px;
    }

    .info {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;

      p {
        &:nth-of-type(1) {
          @include line-clip(2);
          line-height: 22px;
          color: #222;
          font-size: 15px;
          margin-bottom: 10px;
        }

        &:nth-of-type(2) {
          @include line-clip(1);
          color: #999;
          font-size: 13px;
        }
      }
    }
  }
}

.dt-episode-wrap {
  padding: 0 14px;
  margin-bottom: 30px;

  &.zy-select {
    margin-bottom: 18px;
  }
}

.dt-episode-list {
  font-size: 0;

  li {
    display: inline-block;
    width: 18%;
    margin-right: 2.5%;
    margin-bottom: 2.5%;
    height: 50px;
    border-radius: 3px;
    background: #f5f5f5;
    font-size: 15px;
    position: relative;

    &:nth-child(5n) {
      margin-right: 0;
    }
  }

  a {
    color: #000;
    text-align: center;
    display: block;
    width: 100%;
    height: 100%;
    line-height: 50px;
  }

  .tag-vip {
    position: absolute;
    padding: 2px 5px;
    border-radius: 3px;
    background: linear-gradient(to bottom, #ff8e33, #ff7219);
    font-size: 11px;
    color: #fff;
    font-weight: bold;
    right: 0;
    top: 0;
  }

  .tag-pre {
    position: absolute;
    padding: 2px 3px;
    border-radius: 3px;
    background: #999;
    font-size: 11px;
    color: #fff;
    font-weight: bold;
    right: 0;
    top: 0;
  }
}

.dt-episode-choose {
  width: 100%;
  margin-bottom: 15px;
  height: 40px;
  line-height: 40px;
  box-sizing: border-box;
  border-radius: 3px;
  font-size: 13px;
  color: #222;
  border: 1px solid #ccc;
  position: relative;

  &:after {
    content: '';
    @include arr(6px, 135deg, #555);
    @extend %-vertical-center;
    right: 20px;
  }

  select {
    padding-left: 12px;
    width: 100%;
    height: 100%;
    font-size: 15px;
  }

  option {
    padding-left: 12px;
    width: 100%;
    height: 100%;
  }
}
</style>
